module.exports = __webpack_public_path__ + "static/media/educational-papers.86118940.png";